(function () {
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) return;

  function init() {
    if (!window.gsap) return;

    var gsap = window.gsap;
    var light = document.createElement('div');
    light.className = 'cursor-light';
    light.setAttribute('aria-hidden', 'true');
    document.body.appendChild(light);

    var xTo = gsap.quickTo(light, 'x', { duration: 0.6, ease: 'power3' });
    var yTo = gsap.quickTo(light, 'y', { duration: 0.6, ease: 'power3' });
    var opacityTo = gsap.quickTo(light, 'opacity', { duration: 0.4, ease: 'power2' });

    var hasMoved = false;
    var isOverTarget = false;
    var targetSelector = '.category-card, .premium-card__inner, .premium-hero__canvas-wrap, .product__media-item, .scrolling-showcase__item, .why-different__card';

    document.addEventListener('mousemove', function (event) {
      xTo(event.clientX);
      yTo(event.clientY);
      if (!hasMoved) {
        hasMoved = true;
        opacityTo(isOverTarget ? 1 : 0.55);
      }
    });

    document.addEventListener('mouseleave', function () {
      opacityTo(0);
    });

    document.addEventListener('mouseover', function (event) {
      if (event.target.closest && event.target.closest(targetSelector)) {
        isOverTarget = true;
        opacityTo(1);
        gsap.to(light, { scale: 1.25, duration: 0.5, ease: 'power2.out' });
      }
    });

    document.addEventListener('mouseout', function (event) {
      if (event.target.closest && event.target.closest(targetSelector)) {
        isOverTarget = false;
        opacityTo(0.55);
        gsap.to(light, { scale: 1, duration: 0.5, ease: 'power2.out' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
